import CheckInButton from "../CheckInButton/CheckInButton";
import CheckInAvailability from "./CheckInAvailabilty";
import { getBookingCategory, getBookingDisplayText } from "../helpFunctions";

const CheckInRequired = ({ eventData, show = true }) => {
  const isCheckedIn = !!eventData?.checkInDone;
  const isInformation =
    !!eventData?.isInformationBooking
    || getBookingCategory(eventData?.type) === "Information"
    || getBookingDisplayText(eventData) === "Information";

  if (!show || isInformation) {
    return <></>;
  }

  return (
    <div
      style={{
        border: "1px solid #c2bab5",
        borderRadius: ".25rem",
        padding: ".5rem",
        backgroundColor: "#fafafa",
      }}
    >
      <div className={"d-flex"}>
        <div className={"left_flex"}>
          <strong
            style={{
              fontSize: "16px",
            }}
          >
            {isCheckedIn ? "This booking event is checked in" : "This booking event requires check in"}
          </strong>
          <br />
          <span
            style={{
              fontSize: "14px",
            }}
          >
            <CheckInAvailability eventData={eventData} />
          </span>
        </div>
        <div className={"right_flex"}>
          <CheckInButton key={eventData?.id} item={eventData} />
        </div>
      </div>
    </div>
  )
}

export default CheckInRequired
